import { CustomAppLayout } from '../../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Box, Button, Form, FormField, Link, SpaceBetween, Spinner, StatusIndicator } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import CurrencyInput from '../../../../../../components/CurrencyInput';
import Favorites from '../../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { addNotification, buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setData, setLoading } from '../../../../../commons/functions';



export const MembersAccountCasinoPayPage = () => {
    //const storeAdmin = useStoreAdmin();

    useGlobalState();

    const { menu, data } = useGlobalState();
    const [ammount, setAmmount] = useState<number>(0);
    const [ammountFormatted, setAmmountFormatted] = useState<string>(formatCurrency(0, "CLP"));
    const [inputType, setInputType] = useState<"text" | "number" | "password" | "email" | "url">("text");
    const [idMovementTBK, setIdMovementTBK] = useState<number>(0);
    const [movementTBK, setMovementTBK] = useState<any>();
    const [balanceCasino, setBalanceCasino] = useState<number>(0);
    //


    const handleGetBalance = async () => {
        try {

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/login/data',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({})
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                setBalanceCasino(data.balanceCasino);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };

    const handleCasinoPay = async () => {
        try {

            setLoading(true);

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/movements/casino/pay',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    ammount: ammount,
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                setAmmount(0);
                setBalanceCasino(data.balanceCasino);
                setAmmountFormatted(formatCurrency(0, "CLP"))
                addNotification(data.status, 'success', setData);

            } else {
                addNotification(data.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, 'error', setData);
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };

    useEffect(() => {
        handleGetBalance();
    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h2" actions={<Favorites />}
                        description={
                            <>
                                Su saldo actual de su cuenta socios es de:{" "}
                                {balanceCasino !== null && balanceCasino !== undefined ? (
                                    <strong>
                                        {balanceCasino.toLocaleString("es-CL", {
                                            style: "currency",
                                            currency: "CLP",
                                        })}
                                    </strong>
                                ) : (
                                    <Spinner />
                                )}
                                {" "}
                                {balanceCasino > 0 && (
                                    <>
                                        <Link
                                            onClick={() => {
                                                setAmmount(balanceCasino);
                                                setAmmountFormatted(formatCurrency(balanceCasino, "CLP"));
                                            }}
                                        >
                                            Utilizar todo el cupo
                                        </Link>
                                    </>
                                )}
                            </>
                        }
                    >Pagos casino</Header>
                    {balanceCasino !== null && balanceCasino !== undefined && balanceCasino == 0 && (
                        <Alert
                            statusIconAriaLabel="Error"
                            type="error"
                            header="Saldo insuficiente"
                        >Actualmente su saldo de cuenta casino no tiene fondos
                        </Alert>
                    )}
                    {balanceCasino !== null && balanceCasino !== undefined && balanceCasino > 0 && (
                        <Form>
                            <SpaceBetween size="s">
                                <div style={{ width: 300 }}>
                                    <FormField
                                        constraintText="El monto mínimo para abonar es de 1.000 CLP."
                                        label="Monto a abonar (CLP)" description="Ingrese el monto que desea pagar al casino.">
                                        <CurrencyInput value={ammount}
                                            onChange={(v) => {
                                                setAmmount(v)
                                            }} />
                                    </FormField>
                                </div>
                                {ammount > balanceCasino && (
                                    <StatusIndicator type="error">Monto de pago excede saldo remanente</StatusIndicator>
                                )}
                                <div style={{ width: 300 }}>
                                    <Box textAlign='right'><Button variant="primary" disabled={ammount < 1000 || ammount > balanceCasino}
                                        onClick={handleCasinoPay}
                                    >Pagar casino</Button></Box>
                                </div>
                            </SpaceBetween>
                        </Form>
                    )}
                </SpaceBetween>
            }
        />
    );
};
